import React from "react";
import "./WhatsAppFloatingButton.css";

export const WHATSAPP_NUMBER = "917310777481";
export const DEFAULT_WHATSAPP_MESSAGE = "Hi RealFlame, I want to enquire about your PNG Gas Stoves";

const WhatsAppFloatingButton = () => {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_WHATSAPP_MESSAGE)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="global-whatsapp-float-btn"
      aria-label="Chat on WhatsApp with RealFlame Customer Service"
    >
      <div className="global-whatsapp-pulse-ring" />
      <svg viewBox="0 0 32 32" width="28" height="28" fill="#ffffff">
        <path d="M16 2a13.9 13.9 0 0 0-12 21L2 30l7.2-1.9A13.9 13.9 0 1 0 16 2zm0 25.4a11.5 11.5 0 0 1-5.9-1.6l-.4-.2-4.4 1.1 1.2-4.3-.3-.4A11.5 11.5 0 1 1 16 27.4zm6.3-8.6c-.3-.2-2-1-2.3-1.1-.3-.1-.5-.2-.7.2s-.8 1.1-1 1.3c-.2.2-.4.2-.7.1a9.2 9.2 0 0 1-2.7-1.7 10.1 10.1 0 0 1-1.9-2.3c-.2-.3 0-.5.1-.6.1-.1.3-.4.4-.6.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5s-.7-1.7-1-2.3c-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4s-1.2 1.2-1.2 2.9 1.2 3.4 1.4 3.6c.2.2 2.4 3.7 5.8 5.1 2.9 1.2 3.5 1 4.1.9.7-.1 2.2-.9 2.5-1.8.3-.9.3-1.6.2-1.7-.1-.2-.3-.3-.6-.5z" />
      </svg>
      <span className="global-whatsapp-tooltip">Chat with us on WhatsApp</span>
    </a>
  );
};

export default WhatsAppFloatingButton;
